import React from 'react';
import { StaticPage } from '../StaticPage';

export const CommunityRulesPage: React.FC = () => (
  <StaticPage titleKey="static.communityRules">
    <p><em>Stand: 23. April 2026</em></p>

    <p>
      Diese Community Rules ergänzen unsere Nutzungsbedingungen und Datenschutzerklärung.
      Sie gelten für alle öffentlichen und nicht öffentlichen Inhalte und Interaktionen auf I Think It's You,
      insbesondere für Steckbriefe, Antworten, Kommentare, Nachrichten, Profiltexte, Bilder, Meldungen und Beschwerden.
    </p>

    <h2>1. Worum es in dieser Community geht</h2>
    <p>
      I Think It's You ist ein Ort für respektvolle, zurückhaltende und sichere „missed connections".
    </p>
    <p>
      Die Idee ist einfach: Sie hatten eine kurze Begegnung, möchten diese Person auf höfliche Weise
      wiederfinden und beschreiben die Situation so, dass sie wiedererkennbar ist, ohne ihre Privatsphäre
      zu verletzen.
    </p>
    <p>
      <strong>I Think It's You ist kein Ort für:</strong> Nachstellen, öffentliche Bloßstellung,
      Identitätssuche gegen den Willen anderer, Gerüchte, Rache, sexuelle Belästigung, Doxxing,
      Veröffentlichung privater Informationen.
    </p>

    <h2>2. Unsere Grundregeln</h2>
    <p>
      <strong>2.1 Seien Sie respektvoll</strong> – Begegnen Sie anderen so, wie Sie selbst behandelt
      werden möchten: höflich, zurückhaltend und fair.
    </p>
    <p>
      <strong>2.2 Schützen Sie die Privatsphäre anderer</strong> – Schreiben Sie nur so viel, wie nötig
      ist, um die Begegnung zu beschreiben. Vermeiden Sie alles, was eine Person direkt identifizierbar macht.
    </p>
    <p>
      <strong>2.3 Keine Grenzüberschreitungen</strong> – Ein „missed connection"-Post ist kein Freibrief
      für Kontaktzwang.
    </p>
    <p>
      <strong>2.4 Keine öffentliche Fahndung</strong> – Kein Suchdienst, kein Pranger, kein Tracking
      gegen den Willen anderer.
    </p>
    <p>
      <strong>2.5 Sicherheit vor Reichweite</strong> – Im Zweifel gehen Sicherheit, Würde und Datenschutz
      vor Sichtbarkeit.
    </p>

    <h2>3. Was erlaubt ist</h2>
    <p>Erlaubt sind Steckbriefe, die:</p>
    <ul>
      <li>reale Begegnungen beschreiben</li>
      <li>respektvoll formuliert sind</li>
      <li>nur notwendige Details enthalten</li>
      <li>auf Kontakt ausgerichtet sind</li>
      <li>keine Rechte Dritter verletzen</li>
    </ul>
    <p><strong>Beispiele:</strong></p>
    <ul>
      <li>ungefähre Ortsangabe</li>
      <li>ungefähres Zeitfenster</li>
      <li>neutrale Beschreibung</li>
      <li>allgemeine Merkmale</li>
    </ul>

    <h2>4. Was verboten ist</h2>

    <h3>4.1 Identifizierende Daten</h3>
    <p>
      Name, Adresse, Telefonnummer, E-Mail, Social Media Profile, Arbeitsplatz (konkret), Kennzeichen,
      exakte Standorte, sonstige eindeutig identifizierende Daten.
    </p>

    <h3>4.2 Bilder &amp; Aufnahmen</h3>
    <p>
      Keine Fotos, Videos oder Screenshots ohne Einwilligung. Gilt auch für Dating-Profile, Chats,
      private Nachrichten, Überwachungskameras.
    </p>

    <h3>4.3 Doxxing &amp; Identifikation</h3>
    <p>
      Verboten: „Kennt jemand diese Person?", Recherche-Aufrufe, Kombinieren von Hinweisen,
      Verlinken externer Profile.
    </p>

    <h3>4.4 Sensible Daten</h3>
    <p>
      Keine Angaben zu Gesundheit, Herkunft, Religion, Politik, Sexualität, Strafvorwürfen,
      psychischer Gesundheit.
    </p>

    <h3>4.5 Belästigung</h3>
    <p>
      Wiederholte Nachrichten, Druck oder Manipulation, Umgehung von Blockierungen.
    </p>

    <h3>4.6 Hass &amp; Gewalt</h3>
    <p>Diskriminierung, Drohungen, Gewaltverherrlichung.</p>

    <h3>4.7 Sexuelle Inhalte</h3>
    <p>Pornografie, sexualisierte Beschreibungen, entwürdigende Inhalte.</p>

    <h3>4.8 Minderjährige</h3>
    <p>Keine Inhalte über Minderjährige, keine Kontaktversuche, keine Daten.</p>

    <h3>4.9 Rufschädigung</h3>
    <p>Falsche Behauptungen, Gerüchte, öffentliche Anschuldigungen.</p>

    <h3>4.10 Fake Accounts</h3>
    <p>Identitätstäuschung, Nachahmung, falsche Angaben.</p>

    <h3>4.11 Werbung &amp; Spam</h3>
    <p>Werbung, Affiliate-Links, automatisierte Steckbriefe, Massennachrichten.</p>

    <h3>4.12 Technischer Missbrauch</h3>
    <p>Bots, Scraping, Sicherheitsumgehung, Schadcode.</p>

    <h2>5. Besondere Regeln für „Missed Connections"</h2>
    <p>
      <strong>5.1 Situation statt Identität</strong> – Beschreiben Sie die Begegnung, nicht die Person.
    </p>
    <p>
      <strong>5.2 Ungefähre Angaben</strong> – Orte (grob), Zeiträume, allgemeine Merkmale.
    </p>
    <p>
      <strong>5.3 Keine sensiblen Orte</strong> – Keine Steckbriefe über Wohnungen, Hotels, Krankenhäuser,
      Schulen, religiöse Orte, Behörden.
    </p>
    <p>
      <strong>5.4 Kein Stalking</strong> – Nicht erlaubt: Überwachung von Ex-Partner:innen,
      Untreue-Kontrolle, Nachverfolgung.
    </p>
    <p>
      <strong>5.5 Ein Steckbrief pro Begegnung</strong> – Mehrfache Posts können entfernt werden.
    </p>

    <h2>6. Kommentare &amp; Antworten</h2>
    <p>Höflich bleiben, keine Identifizierung, keine Spekulation.</p>
    <p>
      <strong>Verboten:</strong> „Ich kenne sie…", „Das ist X von Instagram", „Ich habe ihre Nummer".
    </p>

    <h2>7. Melden von Inhalten</h2>
    <p>Meldestelle über das Meldeformular. Eine Meldung sollte enthalten:</p>
    <ul>
      <li>Steckbrief oder Account</li>
      <li>Grund</li>
      <li>kurze Erklärung</li>
    </ul>

    <h2>8. Moderation</h2>
    <p>Mögliche Maßnahmen:</p>
    <ul>
      <li>Inhalte ausblenden</li>
      <li>Inhalte löschen</li>
      <li>Reichweite einschränken</li>
      <li>Verwarnung</li>
      <li>Account sperren</li>
    </ul>

    <h2>9. Gründe für Maßnahmen</h2>
    <ul>
      <li>Veröffentlichung privater Daten</li>
      <li>Identifizierbarkeit</li>
      <li>Belästigung</li>
      <li>Missbrauch</li>
      <li>Regelverstöße</li>
    </ul>

    <h2>10. Beschwerde</h2>
    <p>Beschwerden können über das Beschwerdeformular eingereicht werden.</p>

    <h2>11. Kein Anspruch</h2>
    <p>Kein Anspruch auf Veröffentlichung oder Sichtbarkeit.</p>

    <h2>12. Wiederholte Verstöße</h2>
    <p>Mögliche Konsequenzen:</p>
    <ul>
      <li>Dauerhafte Löschung</li>
      <li>Account-Sperre</li>
      <li>Technische Maßnahmen</li>
    </ul>

    <h2>13. Kontakt</h2>
    <p>
      Event Partner Austria Verein<br />
      Kwizdastrasse 9/11<br />
      2100 Korneuburg<br />
      Österreich
    </p>
    <p>
      E-Mail: <a href="mailto:contact@i-think-its-you.at">contact@i-think-its-you.at</a>
    </p>
  </StaticPage>
);
